import { render, staticRenderFns } from "./ValueBasedPricing.vue?vue&type=template&id=79b63714&scoped=true&"
import script from "./ValueBasedPricing.vue?vue&type=script&lang=js&"
export * from "./ValueBasedPricing.vue?vue&type=script&lang=js&"
import style0 from "./ValueBasedPricing.vue?vue&type=style&index=0&id=79b63714&prod&lang=scss&"
import style1 from "./ValueBasedPricing.vue?vue&type=style&index=1&id=79b63714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b63714",
  null
  
)

export default component.exports